export const events = {
  DATA_FETCHED: "dataFetched",
  PROGRAM_RENDERED: "programRendered"
}